import { AccountManager } from '../AccountManager';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class AccountManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers = {}) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/account`, headers);
  }

  createAccountManager(token: string): AccountManager {
    return new AccountManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}
